import { render } from "./Reservations.vue?vue&type=template&id=e2628b6c"
import script from "./Reservations.vue?vue&type=script&lang=js"
export * from "./Reservations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__